import { FeatureDomain } from '@akin-home/amplify';
import { postPageViewLogEvent } from '../../logging';

type InitParams = {
  /** Function to get the users ID */
  getUserID(): string | undefined;
};

type InstanceParams = {
  page: string;
  feature_domain?: FeatureDomain;
  record_id?: string;
};

/** Creates a the main root stack focus event handler. */
export const createFocusEventHandler =
  (params: InitParams) =>
  ({ page, feature_domain, record_id }: InstanceParams) =>
  () => {
    const user_id = params.getUserID();

    user_id &&
      postPageViewLogEvent({
        user_id,
        feature_domain,
        data: {
          page,
          record_id,
        },
      });
  };
